// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3MrlF","large":"styles_large__4zZRl"};